import { QuoteViewActions } from '../reducer';

export default function toggleConvertModal(dispatch) {
  return () => dispatch({ type: QuoteViewActions.TOGGLE_CONVERT_MODAL });
}
